var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.$props.cssClass,attrs:{"for":_vm.$props.for}},[_c('Msg',{attrs:{"id":_vm.$props.id,"css-class":_vm.$props.cssClass,"skip-wrapper":_vm.$props.skipWrapper}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }